
import './App.css';
import { Navbar } from './Components/Navbar';

import { About } from './Pages/About';
import { Contact } from './Pages/Contact';
import { Home } from './Pages/Home';
import { Skills } from './Pages/Skills';
import { Projects } from './Pages/Projects';
import { Footer } from './Pages/Footer';
import { Tools } from './Pages/Tools';
import { Github } from './Pages/Github';
import { useContext } from 'react';
import { themeContext } from './Context';
import { ProfessionalExperiance } from './Pages/ProfessionalExperiance';

function App() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  
  return (
    <div className="App"  style={{
      background: darkMode? '#162030': '', 
      color: darkMode? 'white': '',
      }} >
     
      <Navbar/>
      <Home/>
      <About/>
      <ProfessionalExperiance/>
      <Skills/>
      <Tools/>
      <Projects/>
      <Github/>
      <Contact/>
      {/* <Footer/> */}
      <Footer/>
    </div>
  );
}

export default App;
